// src/App.js
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { HelmetProvider } from 'react-helmet-async';
import { useEffect } from 'react';

import { LanguageProvider, useLang } from './i18n/LanguageContext';
import { SiteConfigProvider } from './context/SiteConfigContext';

import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';

import HomePage from './pages/HomePage';
import PortfolioPage from './pages/portfolio/PortfolioPage';
import PortfolioDetailPage from './pages/portfolio/PortfolioDetailPage';
import BlogPage from './pages/blog/BlogPage';
import BlogDetailPage from './pages/blog/BlogDetailPage';
import TestimonialsPage from './pages/testimonials/TestimonialsPage';

import './styles/globals.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 2, refetchOnWindowFocus: false },
  },
});

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

// Apply RTL/LTR direction and font to document
function DirApplier() {
  const { lang, fontFamily, dir } = useLang();
  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = dir;
    document.body.style.fontFamily = fontFamily;
  }, [lang, fontFamily, dir]);
  return null;
}

export default function App() {
  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <LanguageProvider>
          <SiteConfigProvider>
            <BrowserRouter>
              <DirApplier />
              <ScrollToTop />
              <Navbar />
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/portfolio" element={<PortfolioPage />} />
                <Route path="/portfolio/:slug" element={<PortfolioDetailPage />} />
                <Route path="/blog" element={<BlogPage />} />
                <Route path="/blog/:slug" element={<BlogDetailPage />} />
                <Route path="/testimonials" element={<TestimonialsPage />} />
              </Routes>
              <Footer />
            </BrowserRouter>
          </SiteConfigProvider>
        </LanguageProvider>
      </QueryClientProvider>
    </HelmetProvider>
  );
}
